import { Injectable, signal, computed } from '@angular/core';

/**
 * Tracks in-flight requests that should show the global loading overlay.
 * A counter (not a boolean) so overlapping saves keep the overlay up until
 * the last one finishes.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _activeCount = signal(0);

  /** True while at least one tracked request is in flight. */
  isLoading = computed(() => this._activeCount() > 0);

  start(): void {
    this._activeCount.update((c) => c + 1);
  }

  stop(): void {
    this._activeCount.update((c) => Math.max(0, c - 1));
  }
}
